// extracted by mini-css-extract-plugin
export default {"loading":"fakeLoadingBar_loading__7xEXF","inner":"fakeLoadingBar_inner__reHTH","entering":"fakeLoadingBar_entering__ZG6lm"};